<template>
  <base-warning v-model="modelValue">
    <div class="d-flex flex-column gap-1">
      <p>Posologias conforme idade, peso e comorbidades:</p>

      <figure>
        <img src="/assets/attendance-form/medicine-prescription/dupilumab/table-1.png" alt="" />
        <figcaption>
          Tabela 1 - Se o paciente tem 6 a 11 anos e tem
          <span class="font-weight-bold"> asma e dermatite atópica </span>.
        </figcaption>
      </figure>

      <figure>
        <img src="/assets/attendance-form/medicine-prescription/dupilumab/table-2.png" alt="" />
        <figcaption>
          Tabela 2 - Se o paciente tem 6 a 11 anos e tem diagnóstico
          <span class="font-weight-bold"> apenas de asma </span>.
        </figcaption>
      </figure>

      <figure>
        <img src="/assets/attendance-form/medicine-prescription/dupilumab/table-3.png" alt="" />
        <figcaption>Tabela 3 - Se o paciente tem 12 anos ou mais.</figcaption>
      </figure>

      <p>
        Para solicitar esse medicamento via <span class="font-weight-bold">OPERADORA DE SAÚDE</span>, atente-se para às
        seguintes exigências:
      </p>
      <div v-html="asthmaRequirements['asma-eosinofilica-grave']" />
      <div v-html="asthmaRequirements['asma-alergica-grave']" />
    </div>
  </base-warning>
</template>

<script>
import { ComputedOptions } from 'vue'
import BaseWarning from '../BaseWarning.vue'
import asthmaRequirements from './helper/commonRequirements'

export default {
  components: { BaseWarning },
  name: 'ConductWarning.Dupilumabe',
  props: {
    value: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      asthmaRequirements,
    }
  },
  computed: {
    /** @type {ComputedOptions<boolean>} */
    modelValue: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      },
    },
  },
}
</script>

<style></style>
